var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pagination"},[(_vm.pageTotal > 0)?_c('el-pagination',{attrs:{"background":"","pageSizes":_vm.paginations.pageSizes,"pageSize":_vm.pageSize,"layout":_vm.paginations.layout,"total":_vm.pageTotal,"currentPage":_vm.currentPage},on:{"current-change":_vm.handleCurrentChange,"size-change":_vm.handleSizeChange}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }